import React from 'react';
import classnames from 'classnames';
import flatten from 'lodash/flatten';
import {injectIntl} from 'react-intl';
import {arrayOf, func, string} from 'prop-types';
import {Dropdown, Grid, Icon} from 'semantic-ui-react';
import {mapPropsToDropdownItems, prizeFilterGroups} from 'utils/DBUtils';

class ListPrizesFilterBar extends React.Component {
  static defaultProps = {
    hasNamedFilter: () => false,
    namedFilters: flatten(prizeFilterGroups),
    filterGroups: prizeFilterGroups
  };

  get activeFilters() {
    return this.props.namedFilters.filter(this.props.hasNamedFilter);
  }

  get activeFilterIcons() {
    return this.activeFilters.map(filter => {
      const label = this.props.intl.formatMessage({id: `filter.${filter}`});
      const className = classnames('animResponse fadeInDown', {
        'filter-wrap': label.length > 8
      });

      return (
        <span key={filter} className={className}>
          {label}
          <Icon onClick={() => this.props.onFilterDeselected(filter)} name='close' />
        </span>
      );
    });
  }

  get clearAllIcon() {
    return this.activeFilters.length > 0 && (
      <span className='animResponse fadeInDown filter-bar-clearAll'>
        {this.props.intl.formatMessage({id: `filter.clearAll`})}
        <Icon onClick={this.props.clearAllFilters} name='close' />
      </span>
    );
  }

  render() {
    return (
      <Grid columns={2} className='list-prizes-filter-bar'>
        <Grid.Row>
          <Grid.Column width={10} className='filter-group'>
            {this.activeFilterIcons}
          </Grid.Column>
          <Grid.Column width={6} className='filter-bar-dd'>
            {this.clearAllIcon}
            <Dropdown
              className='db-filter-dropdown'
              text='Select filter'
              selection
              closeOnBlur
              closeOnChange
              openOnFocus={false}>
              <Dropdown.Menu>{mapPropsToDropdownItems(this.props)}</Dropdown.Menu>
            </Dropdown>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default injectIntl(ListPrizesFilterBar);



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/ListPrizesFilterBar.jsx